const NAME = "ONBOARDING_MATERIALS";

export default NAME;
